document.addEventListener('DOMContentLoaded', () => {
  const filterCheckboxes = document.querySelectorAll('.filter-checkbox');
  const sortCheckboxes = document.querySelectorAll('.sort-checkbox');

  filterCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      updateURLParameters();
      updateLabelClass(checkbox);
    });
  });

  sortCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      // Deselect other sorting checkboxes
      sortCheckboxes.forEach(otherCheckbox => {
        if (otherCheckbox !== checkbox) {
          otherCheckbox.checked = false;
          updateLabelClass(otherCheckbox);
        }
      });
      updateURLParameters();
      updateLabelClass(checkbox);
    });
  });

  // Set checkbox states based on URL parameters
  const params = new URLSearchParams(window.location.search);
  filterCheckboxes.forEach(checkbox => {
    const paramName = checkbox.getAttribute('data-param-name');
    const paramValue = checkbox.getAttribute('data-param-value');
    const paramValues = params.getAll(paramName);

    if (paramValues.includes(paramValue)) {
      checkbox.checked = true;
      updateLabelClass(checkbox);
    }
  });

  sortCheckboxes.forEach(checkbox => {
    const paramName = checkbox.getAttribute('data-param-name');
    const paramValue = checkbox.getAttribute('data-param-value');
    const paramValues = params.getAll(paramName);

    if (paramValues.includes(paramValue)) {
      checkbox.checked = true;
      updateLabelClass(checkbox);
    }
  });

  // Initial fetch to load filtered products based on current URL parameters
  //fetchFilteredCollection(window.location.href);
});

function updateURLParameters() {
  const params = new URLSearchParams(window.location.search);
  const filterCheckboxes = document.querySelectorAll('.filter-checkbox');
  const sortCheckboxes = document.querySelectorAll('.sort-checkbox');

  // Clear all the current filter parameters
  filterCheckboxes.forEach(checkbox => {
    const paramName = checkbox.getAttribute('data-param-name');
    params.delete(paramName);
  });

  // Re-add the selected filter parameters
  filterCheckboxes.forEach(checkbox => {
    if (checkbox.checked) {
      const paramName = checkbox.getAttribute('data-param-name');
      const paramValue = checkbox.getAttribute('data-param-value');
      params.append(paramName, paramValue);
    }
  });

  // Clear all the current sort parameters
  params.delete('sort_by');

  // Re-add the selected sort parameters
  sortCheckboxes.forEach(checkbox => {
    if (checkbox.checked) {
      const paramName = checkbox.getAttribute('data-param-name');
      const paramValue = checkbox.getAttribute('data-param-value');
      params.set(paramName, paramValue);
    }
  });

  const newUrl = `${window.location.pathname}?${params.toString()}`;
  window.history.pushState({}, '', newUrl);
  fetchFilteredCollection(newUrl);
}

//function fetchFilteredCollection(url) {
 // fetch(url)
  //  .then(response => response.text())
  //  .then(data => {
   //   const parser = new DOMParser();
   //   const doc = parser.parseFromString(data, 'text/html');
    //  const newProducts = doc.querySelector('.collection-products');

     // document.querySelector('.collection-products').innerHTML = newProducts.innerHTML;
  //  });
//}

function updateLabelClass(checkbox) {
  const label = checkbox.parentNode;
  if (checkbox.checked) {
    label.classList.add('checked');
  } else {
    label.classList.remove('checked');
  }
}